import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import ChartContainer from './containers/ChartContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const data = _.get(totalStats, 'item');

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3 pt-4">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={{
              label: 'Miscellaneous Fees',
              total: _.get(totalStats, 'item.total', 0),
              list: [
                {
                  label: 'Waiting For Payment',
                  value: _.get(data, 'Waiting for Payment', 0),
                  borderClassName: 'waiting',
                },
                {
                  label: 'Paid',
                  value: _.get(data, 'Paid', 0),
                  borderClassName: 'paid',
                },
              ],
            }}
            className="mb-3"
          />
        </div>
        <div className="col-8 pr-0">
          <ChartContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
